import { useQuery } from 'react-query';
import { api } from '#/apis';

const getReportsCache = async () => {

    const { data } = await api.get('/reports-cache');

    return data;
};

export const useReportsCache = (queryOptions = {}) => useQuery('reports-cache-get', () => getReportsCache(queryOptions));
